import Querystring from 'querystring';
import Services from './index';
import {
  GET_PURCHASE_PROCESS_URL,
  LOAD_DID_GROUPS_URL,
  CREATE_DID_GROUP_URL,
  DELETE_DID_GROUP_URL,
  LOAD_DID_IN_GROUPS_URL,
  MOVE_DID_URL,
  AVAILABLE_PHONE_NUMBER_URL,
  BULK_PURCHASE_URL,
  DELETE_SINGLE_DID_URL,
  TOTAL_DID_IN_GROUPS_URL,
  FLUSH_DID,
  SAVE_DID_URL,
  RELEASE_DID_NOW_URL,
  TOTAL_DID_IN_ACCOUNT_URL,
  LOAD_DID_STATS,
  RELEASE_DID_NOW_BY_CLICK_RATE_URL,
  RELEASE_DID_NOW_BY_DELIVERY_RATE_URL,
  GET_COUNTRY_CODE_URL,
  RESET_DID_CYCLE_IN_GROUP_URL,
  MERGE_DID_GROUPS_URL,
  SPLIT_DID_GROUP_URL,
} from 'consts/api';
import { NUMBER_URL } from './PerformanceTrackerService';

class DidServices {
  releaseDidNowByClickRate({ groupId = '', clickRate = '' }) {
    return Services.post(
      `${RELEASE_DID_NOW_BY_CLICK_RATE_URL}?groupId=${groupId}&clickRate=${clickRate}`
    );
  }

  releaseDidNowByDeliveryRate({ groupId = '', deliveryRate = '' }) {
    return Services.post(
      `${RELEASE_DID_NOW_BY_DELIVERY_RATE_URL}?groupId=${groupId}&deliveryRate=${deliveryRate}`
    );
  }

  saveDid({ groupId, body = {} }) {
    return Services.post(`${SAVE_DID_URL}?groupId=${groupId}`, body);
  }

  getCountryCode(groupId) {
    return Services.get(`${GET_COUNTRY_CODE_URL}?groupId=${groupId}`);
  }

  releaseDidNow(groupId, body = { filterSetting: { filters: [] } }) {
    return Services.post(`${RELEASE_DID_NOW_URL}?groupId=${groupId}`, body);
  }

  flushDID(groupId) {
    return Services.get(`${FLUSH_DID}?groupId=${groupId}`);
  }

  getPurchaseProcess(groupId) {
    return Services.get(`${GET_PURCHASE_PROCESS_URL}?groupId=${groupId}`);
  }

  getAvailablePhone(body) {
    return Services.post(AVAILABLE_PHONE_NUMBER_URL, Querystring.stringify(body));
  }

  bulkPurchase(body) {
    return Services.post(BULK_PURCHASE_URL, body);
  }

  moveDid(body = { amount: '', targetGroupId: 0, groupId: 0, filterSetting: { filters: [] } }) {
    return Services.post(MOVE_DID_URL, body);
  }

  moveDidSelected({ targetGroupId, groupId, dids }) {
    return Services.post(MOVE_DID_URL, {
      dids,
      targetGroupId: Number(targetGroupId || 0),
      groupId: Number(groupId || 0),
    });
  }

  loadDIDinGroup(body, configs) {
    return Services.post(LOAD_DID_IN_GROUPS_URL, body, configs);
  }

  totalDidInGroup(id, configs) {
    return Services.post(TOTAL_DID_IN_GROUPS_URL, { id }, configs);
  }

  loadDIDGroup(body) {
    return Services.post(LOAD_DID_GROUPS_URL, body);
  }

  deleteDidGroup(id) {
    return Services.post(DELETE_DID_GROUP_URL, { id });
  }

  createDidGroup(body) {
    return Services.post(CREATE_DID_GROUP_URL, body);
  }

  deleteSingleDidGroup(number) {
    return Services.post(DELETE_SINGLE_DID_URL, { did: number });
  }

  getTotalDidInAccount(body = {}) {
    return Services.post(TOTAL_DID_IN_ACCOUNT_URL, body);
  }

  loadDidGroupStats(id = '') {
    return Services.post(LOAD_DID_STATS, { id });
  }

  resetDIDsCycleInGroup({ groupId }) {
    return Services.put(`${RESET_DID_CYCLE_IN_GROUP_URL}?groupId=${groupId}`);
  }

  scrubDID(groupId) {
    return Services.post(`${NUMBER_URL}/scrubDid?groupId=${groupId}`, {});
  }

  handleBadDid(
    body = {
      groupId: 0,
      action: 'MOVE',
      targetGroupId: 0,
    }
  ) {
    return Services.post(`${NUMBER_URL}/handleBadDid`, body);
  }

  scrubCountries(configs) {
    return Services.get(`${NUMBER_URL}/scrubCountries`, configs);
  }

  async getDidBackgroundProcess({ didGroupId }, configs) {
    try {
      return await Services.get(
        `${NUMBER_URL}/did-group-processing-task?didGroupId=${didGroupId}`,
        configs
      );
    } catch (error) {
      // 404 = no background processing task running for this DID group. That is
      // the normal idle state (the poller runs on a timer), not an error — so
      // resolve to an empty result instead of throwing, which previously made
      // the caller fire a "not found!" toast on every poll.
      if (error?.response?.status === 404) {
        return { data: null };
      }
      throw error;
    }
  }

  mergeDidGroups(body = { name: '', ids: [] }) {
    return Services.post(MERGE_DID_GROUPS_URL, body);
  }

  splitDidGroup({ groupId, amount }) {
    return Services.get(`${SPLIT_DID_GROUP_URL}?groupId=${groupId}&amount=${amount}`);
  }
}

export default new DidServices();
